module.exports = __webpack_public_path__ + "img/bb880ba8b8fcfd54f03d74c95d699c93.04ec07de.png";